export enum CountryCode {
  KW = 'KW',
  SA = 'SA',
}

export type Country = {
  country_code: CountryCode;
};
